import {
  aksesoris,
  bandingkanMobil,
  bodyPaint,
  cubain,
  kuponServis,
  lacakPesanan,
  layananBengkel,
  mobilBaru,
  paketServis,
  sukuCadang,
  testDrive,
  ths,
  tradeIn,
  usedCar,
} from '../assets/images';

const searchResults = [
  {
    id: 1,
    type: 'menuCategory',
    name: 'Mobil Baru',
    icon: mobilBaru.src,
    path: `c/mobil-baru-toyota`,
  },
  {
    id: 2,
    type: 'menuCategory',
    name: 'Workshop Service',
    icon: layananBengkel.src,
    path: `layanan-bengkel`,
  },
  {
    id: 3,
    type: 'menuCategory',
    name: 'Kupon Service',
    icon: kuponServis.src,
    path: `c/kupon-service`,
  },
  {
    id: 4,
    type: 'menuCategory',
    name: 'Aksesoris',
    icon: aksesoris.src,
    path: `c/aksesoris`,
  },
  {
    id: 5,
    type: 'menuCategory',
    name: 'Paket Servis',
    icon: paketServis.src,
    path: `c/paketservistoyota`,
  },
  {
    id: 6,
    type: 'menuCategory',
    name: 'Used Car',
    icon: usedCar.src,
    path: `c/certified-used-car`,
  },
  {
    id: 7,
    type: 'menuCategory',
    name: 'Order Suku Cadang',
    icon: sukuCadang.src,
    path: `services-toyota/suku-cadang`,
  },
  {
    id: 8,
    type: 'menuCategory',
    name: 'Tracking Order',
    icon: lacakPesanan.src,
    path: `tracking-order`,
  },
  {
    id: 9,
    type: 'menuCategory',
    name: 'Home Service',
    icon: ths.src,
    path: `ths-home-service`,
  },
  {
    id: 10,
    type: 'menuCategory',
    name: 'Test Drive',
    icon: testDrive.src,
    path: `c/testdrive-toyota`,
  },
  {
    id: 11,
    type: 'menuCategory',
    name: 'Cubain',
    icon: cubain.src,
    path: `cubain`,
  },
  {
    id: 12,
    type: 'menuCategory',
    name: 'Tukar Tambah',
    icon: tradeIn.src,
    path: `services-toyota/tukar-tambah`,
  },
  {
    id: 13,
    type: 'menuCategory',
    name: 'Bandingkan Mobil',
    icon: bandingkanMobil.src,
    path: `c/mobil-baru-toyota`,
  },
  {
    id: 14,
    type: 'menuCategory',
    name: 'Body Paint',
    icon: bodyPaint.src,
    path: `body-paint-service`,
  },
];

export default searchResults;
